import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { getCreditReport } from '../actions';
import { selectCreditReportParams } from '../selectors';
// The one way components should create the report-fetch action. Every fetch
// must send every enrichment param whose flag is on — the report lives once in
// redux, so a param-less fetch from any screen would overwrite the store with
// enrichment-less data. The returned creator is referentially stable, so it is
// safe in effect dep arrays (useEnsureData relies on this).
const useGetCreditReport = () => {
    const params = useAppSelector(selectCreditReportParams);
    return useCallback(() => getCreditReport(params), [params]);
};
export default useGetCreditReport;
